<template  lang='pug'>
.equity(:class="{'equity-loading': isLoading}")
  .header
  .equity-title(v-show="!isLoading")
    .equity-title-top
      img.title-icon(src="@/assets/imgs/vip/equity_S.png")
      span.top-text {{wrapTitle}}
    .equity-title-main {{wrapInfo}}
      .check-text(@click="openRightPage") 查看权益对比
      img.check-icon(src="@/assets/imgs/vip/ic_topbar_back.png")
  .equity-main
    .equity-list(v-for="(item, index) in privilegeList" :key="`privilegeList_${index}`")
      .items-title {{item.privilegeType}}
      .items-detail-list
        .items-detail(v-for="(subitem, subindex) in item.detailList"
        :key="`detailList_${subindex}`"
        :class="{'one-column': item.showType === 0, 'two-column': item.showType === 1, 'auto-column': item.showType === 2}"
        )
          img.detail-icon(v-if="subitem.icon" :src="subitem.icon")
          img.detail-icon-default(v-else src="@/assets/imgs/vip/checked.png")
          .detail-text-title(:class="{'detail-text-short-title': item.showType === 2, 'detail-text-long-title': item.showType === 0}") {{subitem.title}}
          .detail-text-info(v-if="subitem.info") {{subitem.info}}
</template>

<script>
import service from '@/service/vip/index';
import util from '@/util/index';

export default {
  data() {
    return {
      privilegeList: [],
      wrapUrl: '',
      wrapInfo: '',
      wrapTitle: '',
      isLoading: true,
      keyfrom: '',
    };
  },
  watch: {
    '$route.query': {
      handler(val) {
        if (val.source) {
          this.keyfrom = val.source;
        } else if (val.keyfrom) {
          this.keyfrom = val.keyfrom;
        } else {
          this.keyfrom = '';
        }
      },
      immediate: true,
    },
  },
  methods: {
    init() {
      service.privilegeShow({ t: new Date().getTime() }).then((res) => {
        this.isLoading = false;
        this.privilegeList = res.data.svipPcInfoList.privilegeList;
        // 调试用----s
        // this.privilegeList[2].detailList.forEach((element) => {
        //   element.darkIcon = '@/assets/imgs/vip/equity_S.png';
        //   element.info = '';
        //   element.title = '电脑端水';
        // });
        // this.privilegeList[1].detailList.forEach((element) => {
        //   element.info = '';
        // });
        // this.privilegeList[0].detailList[3].info = '导出word可编辑';
        // this.privilegeList = [...this.privilegeList, ...this.privilegeList];
        // 调试用----e
        this.wrapUrl = this.keyfrom ? `${res.data.svipPcInfoList.wrapUrl}?keyfrom=${this.keyfrom}` : res.data.svipPcInfoList.wrapUrl;
        this.wrapInfo = res.data.svipPcInfoList.wrapInfo;
        this.wrapTitle = res.data.svipPcInfoList.wrapTitle;
      }).catch(() => {
        this.isLoading = true;
      });
    },
    openRightPage() {
      window.open(this.wrapUrl);
      const keyfrom = util.getQueryVariable('keyfrom') || util.getQueryVariable('source');
      window._rlog.push([
        '_trackCustom',
        'event',
        [
          keyfrom ? ['keyfrom', keyfrom] : '',
          ['action', 'privilege_comparison'],
        ],
      ]);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.equity
  width 275px
  height 100%
  background-image url('~@/assets/imgs/vip/equity_bgi.png')
  background-repeat no-repeat
  background-position 100% 100%
  overflow hidden
  border-radius 8px 0px 0px 8px
  .header
    width 275px
    height 39px
  .equity-title
    width 100%
    display flex
    flex-direction column
    justify-content flex-end
    align-items center
    .equity-title-top
      display flex
      justify-content center
      align-items center
      .title-icon
        width 24px
        position relative
        bottom 1px
      .top-text
        font-size 16px
        font-style normal
        font-weight 700
        line-height 24px
        background linear-gradient(174deg, #FFDDBD 0%, #FAA051 100%)
        background-clip text
        -webkit-background-clip text
        -webkit-text-fill-color transparent
    .equity-title-main
      font-size 12px
      color #fff
      opacity 0.6
      line-height 150%
      display flex
      align-items center
      position relative
      left 6px
      margin-top 2px
      .check-text
        color #fff
        margin-left 5px
        cursor pointer
      .check-icon
        width 16px
        height 16px
        margin-top 2px
  .equity-main
    font-size 12px
    .equity-list
      .items-title
        color #FCCEA2
        font-size 12px
        padding-top 26px
        &::before
          content ''
          width 4px
          height 4px
          border-radius 50%
          background-color #FCCDA2
          display inline-block
          margin 0 4px 2px 20px
      .items-detail-list
        display flex
        justify-content start
        flex-wrap wrap
        margin-left 2px
        .items-detail
          margin 14px 0 2px 14px
          color #fff
          position relative
          height  100%
          .detail-icon
            position absolute
            top 50%
            transform translateY(-50%)
            width 24px
            height 24px
          .detail-icon-default
            position absolute
            top 50%
            transform translateY(-50%)
            width 14px
            height 14px
          .detail-text-title
            margin-left 29px
            line-height 19px
          .detail-text-short-title
            margin-left 17px
          .detail-text-long-title
            margin-left 32px
          .detail-text-info
            margin-left 29px
            opacity 0.6
            line-height 130%
        .one-column
          flex 100%
        .one-column:not(:first-child)
          margin-top 11px
        .two-column
          max-width: calc((100% - 28px) / 2);
          min-width: calc((100% - 72px) / 2);
        .two-column:nth-child(2n)
          margin-left 18px
        .auto-column
          flex none
          margin-top 8.5px
.equity-loading
  width 275px
  height 100%
  background url('~@/assets/imgs/vip/equity_bg_loading.png') 0 0 / 100% 100% no-repeat
  overflow: hidden
</style>
